module.exports = __webpack_public_path__ + "static/cortiz-banner-74e258dde63c861066c64dda720d77b3.jpg";